// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__cRAZZ","content":"Main_content__13r0y"};